import { Box, Container, Typography, Link, Stack } from "@mui/material";
import Grid from "@mui/material/Grid"; // Używamy standardowego Grid
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#263238",
        color: "#fff",
        pt: 6,
        pb: 3,
        mt: "auto",
        borderTop: "2px solid #4FC3F7",
      }}
    >
      <Container maxWidth="lg">
        {/* Zmieniono: usunięto 'item', użyto rozmiarów wewnątrz sx lub bezpośrednio (zależnie od wersji MUI) */}
        <Grid container spacing={4}>
          {/* Sekcja 1 */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" fontWeight="700" gutterBottom>
              twojaopiekunka.pl
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9, lineHeight: 1.7 }}>
              Największa baza sprawdzonych opiekunek w Twojej okolicy. Pomagamy
              znaleźć profesjonalną opiekę dla Twoich najbliższych.
            </Typography>
          </Grid>

          {/* Sekcja 2 - LINKI ZAMIENIONE NA ZWYKŁE <a> DLA BEZPIECZEŃSTWA */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" fontWeight="700" gutterBottom>
              Serwis
            </Typography>
            <Stack spacing={1}>
              <Link
                href="/szukaj"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Szukaj opiekunki
              </Link>
              <Link
                href="/cennik"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Cennik
              </Link>
              <Link
                href="/faq"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Pomoc (FAQ)
              </Link>
            </Stack>
          </Grid>

          {/* Sekcja 3 */}
          <Grid item xs={6} md={2}>
            <Typography variant="subtitle1" fontWeight="700" gutterBottom>
              Informacje
            </Typography>
            <Stack spacing={1}>
              <Link
                href="/regulamin"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Regulamin
              </Link>
              <Link
                href="/polityka-prywatnosci"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Polityka prywatności
              </Link>
              <Link
                href="/kontakt"
                color="inherit"
                underline="hover"
                variant="body2"
              >
                Kontakt
              </Link>
            </Stack>
          </Grid>

          {/* Sekcja 4 */}
          <Grid item xs={12} md={3}>
            <Typography variant="subtitle1" fontWeight="700" gutterBottom>
              Kontakt
            </Typography>
            <Stack spacing={1.5}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Typography variant="body2">kontakt@allworks.pl</Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PhoneIcon fontSize="small" />
                <Typography variant="body2">+48 602 209 858</Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: "1px solid rgba(255, 255, 255, 0.2)",
            mt: 6,
            pt: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="caption" sx={{ display: "block", opacity: 0.8 }}>
            &copy; {new Date().getFullYear()} Allworks sp. z o.o. Wszelkie prawa
            zastrzeżone.
          </Typography>
          <Typography variant="caption" sx={{ opacity: 0.6 }}>
            Realizacja:{" "}
            <Link
              href="https://michaljaskulski.pl"
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              sx={{ fontWeight: "bold" }}
            >
              Michał Jaskulski
            </Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
